import "./index.scss";
import { insertDocument } from '../../../common/utils';

const downloadAppHtml = function (config) {
  return `
  <div class="download-app-content clearfix">
    <img class="app-logo" src="${config.imageUrl}" />
    <p>${config.titleContent}</p>
  </div>
  <div class="download-app-actions">
    <span id="smart-cancel" class="new-download-app app-not-now" data-ck="wap_smartbanner" data-cancel="true">${config.notNowButton}</span>
    <span id="smart-download" class="new-download-app app-download" data-ck="wap_smartbanner" data-page="home" data-link-params="bucketName=${config.bucketName}">${config.viewInAppButton}</span>
  </div>
`
}

function DownloadApp (config) {
  
  const defautlConfig = {
    bucketName: '',
    id: 'smart-download-app-wrap',
    notNowButton: 'NOT NOW',
    viewInAppButton: 'Download app',
    titleContent: 'Download now to find exclusive discounts on the app.',
    imageUrl: 'https://gw.alicdn.com/tfs/TB1u2YsHa6qK1RjSZFmXXX0PFXa-100-100.gif'
  }

  this.showState = false;
  this.config = Object.assign(defautlConfig, config);

  this.init = () => {

    // 如果页面中已经存在，则直接显示即可
    if (document.getElementById('smart-download')) {
      this.show(true);
      return;
    }

    // 实例化dom结构
    const DomFragment = downloadAppHtml(this.config);
    insertDocument(DomFragment, this.config.id);

    // 监听关闭事件
    document.getElementById('smart-cancel').addEventListener('click', (e) => {
      this.hide();
    })
  }
  this.hide = () => {
    const ele = document.getElementById(this.config.id);
    if (!this.showState || !ele) return;
    this.showState = false;
    document.getElementById(this.config.id).className = `${this.config.id} close`;
    // 300ms后自动清空dom
    setTimeout(() => {
      ele.parentNode.removeChild(ele);
    }, 300)
  }
  this.show = (noLog) => {
    const ele = document.getElementById(this.config.id);
    if (this.showState || !ele) return;
    this.showState = true;
    document.getElementById(this.config.id).className = `${this.config.id} show`;
    noLog && this.dot();
  }
  // 后面增加曝光功能后，会全部下掉
  this.dot = () => {
    // status 0曝光 1取消 2下载
    if (!this.config.bucketName) return;
    window.goldlog && window.goldlog.record('/sc.mobile.download-app','CLK',`action=expose&ck=wap_smartbanner&bucketName=${this.config.bucketName}&pageid=${window.dmtrack_pageid}`,'GET')
  }
  // 初始化的时候自动调用init
  this.init()
}


// 初始化
export default DownloadApp;



// WEBPACK FOOTER //
// ./src/modules/download-app/smart/index.js